import {GET_USERS as SOCKET_GAVE_USERS, GAVE_EXP_USER as SOCKET_GAVE_EXP_USER, DELETE_TEMPORARY_USER as SOCKET_DELETE_TEMPORARY_USER} from '../../events/DashboardToServer'
import {PLAYER_MODERATED, PLAYER_ADDED, PLAYER_REMOVED, TEMPORARY_USER_DELETED} from '../../events/ServerToClient'
import { USER_DELETED } from '../user/actions';

export const GET_USERS = 'GET_USERS'
export const USERS_RECEIVED = 'USERS_RECEIVED'
export const GET_EXP_USER = 'GET_EXP_USER'
export const EXP_USER_RECEIVED = 'EXP_USER_RECEIVED'
export const SAVED_EXP_USER = 'SAVED_EXP_USER'
export const SAVED_NEW_USERNAME = 'SAVED_NEW_USERNAME'
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const DELETE_TEMPORARY_USER = 'DELETE_TEMPORARY_USER'


export const users = (state = {}, action) => {
    switch (action.type) {
    
        case EXP_USER_RECEIVED:
            var e = {
                ...state
            }
            e[action.exp_user.user_id] ={
                ...e[action.exp_user.user_id],
                exp_user : {
                    ...action.exp_user
                }
            }
            return e;

        case SAVED_NEW_USERNAME:
            var e = {
                ...state
            }
            e[action.user_id] ={
                ...e[action.user_id],
                username : action.username
            }
            return e;

        case SAVED_EXP_USER:
            var e = {
                ...state
            };
            var restExpUser =  e[action.exp_user.user_id]?e[action.exp_user.user_id].exp_user:{}
            e[action.exp_user.user_id] = {
                ...e[action.exp_user.user_id],
                exp_user : {
                    ...restExpUser,
                    from: action.exp_user.from, 
                    claim: action.exp_user.claim,
                    real_name   : action.exp_user.real_name,
                    paypal_account: action.exp_user.paypal_account,
                    has_webcam: action.exp_user.has_webcam,
                    avatar: action.exp_user.avatar,
                }
            }
            return e

        case PLAYER_MODERATED:
        var e = {
            ...state
        };
        e[action.user.id] = {
            ...e[action.user.id], 
            exp_user: {
                ...e[action.user.id].exp_user,
                is_banned : !(e[action.user.id].exp_user.is_banned)
            }
        }
        return e;

        case USERS_RECEIVED:
            var e = {
                ...state
            }
            for (var i = 0; i < action.users.length; i++){
                e[action.users[i].id] = {
                    ...action.users[i]
                }
            }
            return e

        case USER_DELETED:
            var e = {
                ...state
            }
            if (e[action.user_id])
                delete e[action.user_id]
            return e
        
        case USER_LOGGED_IN:
            var e = {
                ...state
            };
            if (!(e[action.user.id])){
                // Se entro qui detto vuol dire che l'utente si è registrato
            // dopo il log del conduttore 
                e[action.user.id] ={
                    ...action.user,
                    exp_user: {
                        ...action.user.exp_user
                    } 
                }
            }
            e[action.user.id] = {
                ...e[action.user.id], 
                is_connected : !action.user.error?1:0,
            }
            return e;

        case USER_LOGGED_OUT:
            var e = {
                ...state
            };
            e[action.user.id] = {
                ...e[action.user.id], 
                is_connected : 0
            }
            return e;

        case PLAYER_ADDED:
            var e = {
                ...state
            };
            e[action.user_id] = {
                ...e[action.user_id], 
                is_playing : 1
            }
            return e;

        case PLAYER_REMOVED:
            var e = {
                ...state
            };
            e[action.user_id] = {
                ...e[action.user_id], 
                is_playing : 0
            }
            return e;
                
        default:
            return state
    }
}

export const getUsers = (socket) => {
    socket.emit(SOCKET_GAVE_USERS)
    return { type: GET_USERS}
}

export const receiveUsers = ({users}) => {
    return { type: USERS_RECEIVED, users}
}

export const getExpUser = (socket, user_id) => {
    socket.emit(SOCKET_GAVE_EXP_USER, {user_id})
    return { type: GET_EXP_USER, user_id}
}

export const receiveExpUser = (exp_user) => {
    return { type: EXP_USER_RECEIVED, exp_user}
}

export const savedExpUser = (exp_user,user_id) => {
    return { type: SAVED_EXP_USER, exp_user, user_id}
}

export const playerAdded = (user_id) => {
    return { type: PLAYER_ADDED , user_id}
}

export const playerRemoved = (user_id) => {
    return { type: PLAYER_REMOVED, user_id}
}

export const savedNewUsername = (username,user_id) => {
    return { type: SAVED_NEW_USERNAME, username, user_id}
}

export const userLoggedIn = (user) => {
    return {type: USER_LOGGED_IN, user}
}

export const userLoggedOut = (user) => {
    return {type: USER_LOGGED_OUT, user}
}

export const temporaryUserDeleted = () => {
    console.log("TEMPORARY USER DELETED")
    return {type:TEMPORARY_USER_DELETED}
}

export const deleteTemporaryUser =(socket) => {
    socket.emit(SOCKET_DELETE_TEMPORARY_USER);
    return {type: DELETE_TEMPORARY_USER}
}



// WEBPACK FOOTER //
// ./src/reducers/users/index.js